import client from '../request'

//get all
const getAll = '/weight-based-shipping-rules'

//get by id
const get = (id) => {
  return `/weight-based-shipping-rules/${id}`
}

// axios
const create = (data) => {
  return client.post('/weight-based-shipping-rules', data)
}

// axios
const update = (id, data) => {
  return client.put(`/weight-based-shipping-rules/${id}`, data)
}

// axios
const remove = (id) => {
  return client.delete(`/weight-based-shipping-rules/${id}`)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id,
        tracking_company_name: element.trackingCompany?.name || 'N/A'
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const WeightBasedShippingRuleService = {
  getAll,
  get,
  create,
  update,
  remove,
  toRow,
  toPaginate
}

export default WeightBasedShippingRuleService
